/**
 * Public asset URL for the pre-rendered welcome clip (no TTS API on first play).
 * File: `web-dashboard/public/audio/voice-agenda-welcome.wav`
 * Regenerate: `web-dashboard/scripts/generate-voice-agenda-welcome-audio.sh`
 */
export const VOICE_AGENDA_WELCOME_AUDIO_URL = `${import.meta.env.BASE_URL}audio/voice-agenda-welcome.wav`;
